// extracted by mini-css-extract-plugin
export default {"totalCaptures":"styles_totalCaptures__192Vt"};